exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.box {\n  margin: 0 auto;\n  max-height: 300px;\n  max-width: 300px;\n  text-align: center;\n  margin-top: 20%;\n  box-shadow: 0px 0px !important; \n}\n\ninput {\n  background-color: #E5E5E5;\n  border-radius: 3px;\n  margin: 5px;\n  max-width: 250px;\n}\n\n:-ms-input-placeholder {\n  color: #958FA2;\n}\n\n::placeholder {\n  color: #958FA2;\n}\n\nbutton {\n  width: 250px;\n  max-width: 250px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  color: black;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main